import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  CustomTabView,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
} from '../../../../components'
import * as ProdutoHttp from '../../../../services/api/https/registration/produto.http'
import { formatIsoDateToLocale } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { TabPanel } from 'primereact/tabview'
import DesdobramentoProduto from './ModalProdutoDesdobramento'
import ModalProdutoPosicoesEstoquePadrao from './ModalProdutoPosicoesEstoquePadrao'
import ModalProdutoDePara from './ModalProdutoDePara'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  CREATE: 'Criando produto',
  UPDATE: 'Atualizando produto',
  SUCCESS: 'Produto salvo com sucesso',
}

const INITIAL_STATE = {
  produto: {
    id: null,
    product_code: '',
    company_id: '',
    name: '',
    weight: '',
    unit_sku: '',
    m3: '',
    actived: true,
    ordem_separacao: '',
    caixa_com_peso_variavel: false,
    grupo_produto_id: '',
    weight_liquido: '',
    qte_por_pallet: '',
    dias_para_vencimento: '',
    participa_calculo_paletizacao: true,
    picking_add_lote: false,
    picking_add_data_validade: false,
    picking_add_data_fabricacao: false,
    picking_add_info_complementar: false,
    picking_add_lote_recebimento: false,
    picking_add_data_validade_recebimento: false,
    un_agregadora: '',
    un_fracionada: '',
    inventario_add_lote: false,
    inventario_add_data_validade: false,
    estoque_minimo: '',
    updated_at: null,
  },
  savedProduto: {},
  activeTab: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const MANDATORY_FIELDS = {
  PRODUCT_CODE: 'O codigo do produto deve ser preenchido',
  NAME: 'O nome do produto deve ser preenchido',
  WEIGHT: 'O peso produto do produto deve ser preenchido',
  UNIT_SKU: 'O numero de unidades por SKU deve ser preenchido',
  M3: 'O volume de m³ por SKU deve ser preenchido',
}

const ModalProduto = ({
  data,
  show,
  onModalSave,
  onModalClose,
  dispatch,
  grupos = [],
  alertMessage,
  selectedTp,
  empresas = [],
}) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show) {
      setState(prevState => ({
        ...prevState,
        produto: {
          ...INITIAL_STATE.produto,
          ...data,
          un_agregadora: data.un_agregadora || '',
          un_fracionada: data.un_fracionada || '',
          estoque_minimo:
            data.estoque_minimo !== null && data.estoque_minimo !== undefined
              ? data.estoque_minimo
              : '',
        },
        activeTab: 0,
      }))
    }
  }, [show])

  useEffect(() => {
    if (state.activeTab === 2 && (!selectedTp || selectedTp === 0)) {
      setState(prevState => ({ ...prevState, activeTab: 0 }))
    }
  }, [selectedTp, state.activeTab])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.CREATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveProduto(state.produto)
        break

      case LOAD_MESSAGE.UPDATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        updateProduto(state.produto)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedProduto)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  // Events
  const onBtnSalvarClicked = produto => {
    if (validateFieldsBeforeSubmit(produto)) {
      if (produto.id) setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.UPDATE }))
      else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE }))
    }
  }

  const onFormChange = (name, value) => {
    setState(prevState => {
      if (name === 'grupo_produto_id') {
        prevState.produto.grupo_produto_id = value.id
      } else {
        prevState.produto[name] = value
      }
      return { ...prevState }
    })
  }

  const onTabChange = value => {
    if (value === 2 && (!selectedTp || selectedTp === 0)) {
      dispatch(showMessageBox(null, 'Selecione um Operador Logístico'))
      return
    }

    setState(prevState => ({ ...prevState, activeTab: value }))
  }

  // Helper
  const saveProduto = produto => {
    const ordemSeparacao =
      produto.ordem_separacao && typeof produto.ordem_separacao == 'string'
        ? Number(produto.ordem_separacao.trim())
        : null
    ProdutoHttp.saveProduto({
      product_code: produto.product_code.trimStart().trimEnd(),
      company_id: produto.company_id,
      name: produto.name.trimStart().trimEnd(),
      weight: produto.weight,
      unit_sku: produto.unit_sku,
      m3: produto.m3,
      actived: produto.actived,
      participa_calculo_paletizacao: produto.participa_calculo_paletizacao,
      picking_add_lote: produto.picking_add_lote,
      picking_add_data_validade: produto.picking_add_data_validade,
      picking_add_info_complementar: produto.picking_add_info_complementar,
      picking_add_data_fabricacao: produto.picking_add_data_fabricacao,
      picking_add_lote_recebimento: produto.picking_add_lote_recebimento,
      picking_add_data_validade_recebimento: produto.picking_add_data_validade_recebimento,
      inventario_add_lote: produto.inventario_add_lote,
      inventario_add_data_validade: produto.inventario_add_data_validade,
      ordem_separacao: ordemSeparacao,
      caixa_com_peso_variavel: produto.caixa_com_peso_variavel,
      grupo_produto_id: produto.grupo_produto_id === '' ? null : produto.grupo_produto_id,
      weight_liquido: produto.weight_liquido === '' ? null : produto.weight_liquido,
      qte_por_pallet: produto.qte_por_pallet === '' ? null : produto.qte_por_pallet,
      dias_para_vencimento:
        produto.dias_para_vencimento === '' ? null : produto.dias_para_vencimento,
      un_agregadora: produto.un_agregadora === '' ? null : produto.un_agregadora,
      un_fracionada: produto.un_fracionada === '' ? null : produto.un_fracionada,
      estoque_minimo: produto.estoque_minimo === '' ? null : produto.estoque_minimo,
    })
      .then(produto =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
          savedProduto: produto,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const updateProduto = produto => {
    const ordemSeparacao =
      produto.ordem_separacao && typeof produto.ordem_separacao == 'string'
        ? Number(produto.ordem_separacao.trim())
        : null
    ProdutoHttp.updateProduto({
      id: produto.id,
      product_code: produto.product_code.trimStart().trimEnd(),
      company_id: produto.company_id,
      name: produto.name.trimStart().trimEnd(),
      weight: produto.weight,
      unit_sku: produto.unit_sku,
      m3: produto.m3,
      actived: produto.actived,
      participa_calculo_paletizacao: produto.participa_calculo_paletizacao,
      ordem_separacao: ordemSeparacao,
      caixa_com_peso_variavel: produto.caixa_com_peso_variavel,
      picking_add_lote: produto.picking_add_lote,
      picking_add_data_validade: produto.picking_add_data_validade,
      picking_add_info_complementar: produto.picking_add_info_complementar,
      picking_add_data_fabricacao: produto.picking_add_data_fabricacao,
      picking_add_lote_recebimento: produto.picking_add_lote_recebimento,
      picking_add_data_validade_recebimento: produto.picking_add_data_validade_recebimento,
      inventario_add_lote: produto.inventario_add_lote,
      inventario_add_data_validade: produto.inventario_add_data_validade,
      grupo_produto_id: produto.grupo_produto_id === '' ? null : produto.grupo_produto_id,
      weight_liquido: produto.weight_liquido === '' ? null : produto.weight_liquido,
      qte_por_pallet: produto.qte_por_pallet === '' ? null : produto.qte_por_pallet,
      dias_para_vencimento:
        produto.dias_para_vencimento === '' ? null : produto.dias_para_vencimento,
      un_agregadora: produto.un_agregadora === '' ? null : produto.un_agregadora,
      un_fracionada: produto.un_fracionada === '' ? null : produto.un_fracionada,
      estoque_minimo: produto.estoque_minimo === '' ? null : produto.estoque_minimo,
    })
      .then(produto =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
          savedProduto: produto,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const formatUltimaModificacao = value => {
    if (typeof value !== 'string' || !value) return ''
    const date = formatIsoDateToLocale(value)
    return date.isValid ? `Última modificação: ${date.toFormat('dd/MM/yyyy HH:mm:ss')}` : ''
  }

  const validateFieldsBeforeSubmit = fields => {
    const mandatoryFields = {
      product_code: fields.product_code,
      name: fields.name,
      weight: fields.weight,
      unit_sku: fields.unit_sku,
      m3: fields.m3,
    }
    const names = Object.keys(mandatoryFields)
    return names.every(field => {
      if (mandatoryFields[field] && mandatoryFields[field].toString().trim() !== '') {
        return true
      }
      setState(prevState => ({ ...prevState, errorMessage: MANDATORY_FIELDS[field.toUpperCase()] }))
      return false
    })
  }

  // Render
  return (
    <CustomModal
      header="Produto"
      isVisible={show}
      onClose={onModalClose}
      style={{ maxWidth: '95vw' }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      {alertMessage ? (
        <div
          style={{
            marginBottom: 12,
            padding: 10,
            borderRadius: 4,
            color: '#7F1D1D',
            backgroundColor: '#FEE2E2',
            border: '1px solid #FCA5A5',
            fontSize: '0.85rem',
          }}
        >
          <strong>Inconsistências identificadas:</strong> {alertMessage}
        </div>
      ) : null}
      <CustomTabView activeIndex={state.activeTab} onTabChange={onTabChange}>
        <TabPanel header={'Dados'}>
          <form className="p-grid" style={{ width: 650 }}>
            <div className="p-col-12">
              <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}>(*) Campos Obrigatórios</span>
            </div>
            <div className="p-col-4">
              <InputText
                label="Código* :"
                marginTop={10}
                value={state.produto.product_code}
                onChange={value => onFormChange('product_code', value)}
              />
            </div>
            <div className="p-col-12">
              <InputText
                label="Produto* :"
                marginTop={10}
                value={state.produto.name}
                onChange={value => onFormChange('name', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroDecimal
                label="Peso Bruto por Caixa/Volume* :"
                value={state.produto.weight}
                onChange={value => onFormChange('weight', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroDecimal
                label="Peso Liquido por SKU :"
                value={state.produto.weight_liquido}
                onChange={value => onFormChange('weight_liquido', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Unidade por SKU* :"
                value={state.produto.unit_sku}
                onChange={value => onFormChange('unit_sku', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Qte Por Pallet :"
                value={state.produto.qte_por_pallet}
                onChange={value => onFormChange('qte_por_pallet', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroDecimal
                label="Volume m3 por Sku* :"
                decimalScale={4}
                value={state.produto.m3}
                onChange={value => onFormChange('m3', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Dias Para Vencimento :"
                marginTop={20}
                value={state.produto.dias_para_vencimento}
                onChange={value => onFormChange('dias_para_vencimento', value)}
              />
            </div>
            <div className="p-col-6">
              <InputNumeroInteiro
                label="Ordem de Separação :"
                marginTop={10}
                value={state.produto.ordem_separacao}
                onChange={value => onFormChange('ordem_separacao', value)}
              />
            </div>
            <div className="p-col-6">
              <CustomDropdown
                label="Grupo de Produto"
                optionLabel="nome"
                options={grupos}
                value={
                  state.produto.grupo_produto_id
                    ? grupos.find(g => g.id === state.produto.grupo_produto_id)
                    : ''
                }
                onChange={value => onFormChange('grupo_produto_id', value)}
              />
            </div>
            <div className="p-col-6">
              <InputText
                label="Unidade Agregadora :"
                marginTop={10}
                value={state.produto.un_agregadora}
                onChange={value => onFormChange('un_agregadora', value)}
              />
            </div>
            <div className="p-col-6">
              <InputText
                label="Unidade Fracionada :"
                marginTop={10}
                value={state.produto.un_fracionada}
                onChange={value => onFormChange('un_fracionada', value)}
              />
            </div>
            <div className="p-col-6">
              <InputNumeroDecimal
                label="Estoque Mínimo :"
                value={state.produto.estoque_minimo}
                onChange={value => onFormChange('estoque_minimo', value)}
              />
            </div>
            <div className="p-col-6"></div>
            <div className="p-col-2" style={{ paddingTop: 45 }}>
              <CustomCheckbox
                onChange={value => onFormChange('actived', value)}
                checked={state.produto.actived}
              >
                Ativo
              </CustomCheckbox>
            </div>
            <div className="p-col-4" style={{ paddingTop: 45 }}>
              <CustomCheckbox
                onChange={value => onFormChange('caixa_com_peso_variavel', value)}
                checked={state.produto.caixa_com_peso_variavel}
              >
                Caixa Com Peso Variável
              </CustomCheckbox>
            </div>
            <div className="p-col-6" style={{ paddingTop: 45 }}>
              <CustomCheckbox
                onChange={value => onFormChange('participa_calculo_paletizacao', value)}
                checked={state.produto.participa_calculo_paletizacao}
              >
                Participa do Cálculo de Paletização
              </CustomCheckbox>
            </div>
            <div className="p-col-12" style={{ paddingTop: 30 }}>
              <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}>
                {' '}
                Picking - Por Cliente/ Por Cliente-Estoque:
              </span>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('picking_add_lote', value)}
                checked={state.produto.picking_add_lote}
              >
                Lote obrigatório
              </CustomCheckbox>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('picking_add_data_validade', value)}
                checked={state.produto.picking_add_data_validade}
              >
                Data de validade obrigatória
              </CustomCheckbox>
            </div>
            <div className="p-col-12" style={{ paddingTop: 30 }}>
              <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}> Picking - Recebimento:</span>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('picking_add_lote_recebimento', value)}
                checked={state.produto.picking_add_lote_recebimento}
              >
                Lote obrigatório
              </CustomCheckbox>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('picking_add_data_validade_recebimento', value)}
                checked={state.produto.picking_add_data_validade_recebimento}
              >
                Data de validade obrigatória
              </CustomCheckbox>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('picking_add_data_fabricacao', value)}
                checked={state.produto.picking_add_data_fabricacao}
              >
                Data de fabricação obrigatória
              </CustomCheckbox>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('picking_add_info_complementar', value)}
                checked={state.produto.picking_add_info_complementar}
              >
                Info complementar obrigatória
              </CustomCheckbox>
            </div>
            <div className="p-col-12" style={{ paddingTop: 30 }}>
              <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}> Inventário:</span>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('inventario_add_lote', value)}
                checked={state.produto.inventario_add_lote}
              >
                Lote obrigatório
              </CustomCheckbox>
            </div>
            <div className="p-col-6" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                onChange={value => onFormChange('inventario_add_data_validade', value)}
                checked={state.produto.inventario_add_data_validade}
              >
                Data de validade obrigatória
              </CustomCheckbox>
            </div>
            <div
              className="p-col-12"
              style={{
                paddingTop: 32,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span style={{ fontSize: '0.8rem', color: '#14B0BF' }}>
                {formatUltimaModificacao(state.produto.updated_at)}
              </span>
              <Btn onClick={() => onBtnSalvarClicked(state.produto)}>Salvar</Btn>
            </div>
          </form>
        </TabPanel>
        <TabPanel header={'Desdobramento'} disabled={!state.produto.id}>
          <DesdobramentoProduto
            produtoId={state.produto && state.produto.id ? state.produto.id : null}
            onResponse={(action, payload) => {
              if (action === 'error') dispatch(showMessageBox(null, payload))
              if (action === 'success') dispatch(showMessageBox(payload, null))
            }}
          />
        </TabPanel>
        <TabPanel
          header={'Posições Estoque Padrão'}
          disabled={!state.produto.id || !selectedTp || selectedTp === 0}
        >
          <ModalProdutoPosicoesEstoquePadrao
            produtoId={state.produto && state.produto.id ? state.produto.id : null}
            selectedTp={selectedTp}
            active={state.activeTab === 2}
            onResponse={(action, payload) => {
              if (action === 'error') dispatch(showMessageBox(null, payload))
              if (action === 'success') dispatch(showMessageBox(payload, null))
            }}
          />
        </TabPanel>
        <TabPanel header={'De/Para'} disabled={!state.produto.id}>
          <ModalProdutoDePara
            produto={state.produto}
            empresas={empresas}
            active={state.activeTab === 3}
            onResponse={(action, payload) => {
              if (action === 'error') dispatch(showMessageBox(null, payload))
              if (action === 'success') dispatch(showMessageBox(payload, null))
            }}
          />
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

export default connect()(ModalProduto)
